export default __webpack_public_path__ + "static/media/Sidarth.a1b064cc.jpg";